import { ToastService } from './../../../../../../core/toast.service';
import { SupplyService } from './../../../../../../core/services/supply.service';
import { Supply } from './../../../../../../core/models/supply';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private dialogRef: MatDialogRef<DeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Supply,
    private supplyService: SupplyService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

/* ------------------------------ Close Dialog ------------------------------ */

  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

  delete(){
    this.supplyService.deleteSupplyByPk(this.data.id).
    subscribe(success=>{
      this.toast.openSnackBar("This product is deleted successfully");
      this.closeDialog('yes');
    },failure => {
      this.toast.openSnackBar("Unable to send for approval");
    })
  }
}



